import { put, select, takeLatest, all, fork } from "redux-saga/effects";
import * as types from "./featuresTypes";
import * as totalDataTypes from "~/store/totalData/types";
import * as feeTypes from "~/store/fee/feeTypes";
import * as actions from "./featuresActions";
import * as loginActions from "~/store/login/actions";
import axios from "axios";
import history from "~/history";
import { FEATURE_TYPES } from "~/utils/constants";
import { client } from "~/utils/medproSDK";

function* requestAllFeatures() {
  try {
    yield put(actions.loadingAllFeatures());
    const partnerid = yield select(state => state.totalData.partnerId);
    const cskhtoken = yield select(
      state => state.customerService.selectedPatient.secretKey
    );

    const hospitalSelected = yield select(
      state => state.totalData.hospitalSelected
    );
    axios.defaults.headers.partnerid = partnerid;
    const header = {
      partnerid,
      cskhtoken,
      version: "1"
    };
    const response = yield client.getFeatureByPartner(header);

    if (response.status !== 200 || response.data.error_code)
      throw new Error("Lỗi server!");
    const { data } = response;
    // page home: ko auto chọn
    // check đã chọn bv hay chưa
    if (hospitalSelected !== null) {
      if (data.length === 1) {
        yield put({ type: types.SELECT_FEATURE, payload: data[0].type });
      } else {
        const url = `${partnerid}/chon-hinh-thuc-dat-kham`;
        history.push(url);
      }
    }
    yield put(actions.requestAllFeaturesSuccess(data));
  } catch (error) {
    yield put(actions.requestAllFeaturesFail(error));
  }
}

function* watcherRequestAllFeatures() {
  yield takeLatest(types.REQUEST_ALL_FEATURES, requestAllFeatures);
}

// SELECT FEATURE
function* requestSelectFeature({ payload }) {
  const IsAuthenticated = yield select(state => state.user.IsAuthenticated);
  if (payload.includes("booking")) {
    const flow = payload.split(".")[1];
    // reset dữ liệu của luồng trước (chỉ giữ bệnh viện đang chọn) để không gửi nhầm sang luồng mới
    yield put({ type: totalDataTypes.RESET_BOOKING_FLOW_DATA });
    yield put({ type: totalDataTypes.CHANGE_BOOKING_FLOW, flow });
    yield put({ type: totalDataTypes.GET_BOOKING_TREE });
  } else {
    switch (payload) {
      case FEATURE_TYPES.paymentFee: {
        history.push("/tim-ma-thanh-toan-vien-phi");
        break;
      }
      case FEATURE_TYPES.paymentFeeHistory: {
        if (!IsAuthenticated) {
          yield put(loginActions.redirectToMedproId());
        } else {
          yield put({ type: feeTypes.GET_HISTORY_PAYMENT });
        }
        break;
      }
      case FEATURE_TYPES.eInvoice: {
        yield history.push("/tra-cuu-hoa-don-dien-tu");
        break;
      }
      default: {
        return "";
      }
    }
  }
}

function* watcherSelectFeature() {
  yield takeLatest(types.SELECT_FEATURE, requestSelectFeature);
}

export default function* root() {
  yield all([fork(watcherRequestAllFeatures), fork(watcherSelectFeature)]);
}
